module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Black.5c00bf40e56583a93720445419981ad8.eot";